var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeakerSimpleHigh = function SvgIconSpeakerSimpleHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.69 2.102a1 1 0 0 1 .56.898v18a1 1 0 0 1-1.614.79l-6.48-5.04H3A1.75 1.75 0 0 1 1.25 15V9A1.75 1.75 0 0 1 3 7.25h4.157l6.48-5.04a1 1 0 0 1 1.052-.108m-1.44 2.943L8.114 9.039a1 1 0 0 1-.614.211H3.25v5.5H7.5a1 1 0 0 1 .614.21l5.136 3.995zM18 8.75a1 1 0 0 1 1 1v4.5a1 1 0 1 1-2 0v-4.5a1 1 0 0 1 1-1m4.375-.5a1 1 0 1 0-2 0v7.5a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeakerSimpleHigh;